import { filenameFromContentDisposition } from '@/lib/download-blob'
import { isRecord, json, request, requireString, send } from '@/lib/api'

import { decodeReportRun } from '../lib/query-result'
import { sqlEnvelope, structuredEnvelope, type ReportQueryDefinition } from '../lib/report-query'

export type ReportPagination = { limit: number; after: string | null }

const base = (entityId: string | null) => entityId === null ? '/api/v1/reports' : `/api/v1/entities/${encodeURIComponent(entityId)}/reports`

function draftEnvelope(definition: ReportQueryDefinition | null, rawQuery: string | null): string | null {
  if (definition) return structuredEnvelope(definition)
  return rawQuery === null ? null : sqlEnvelope(rawQuery)
}

export const reportPreviewApi = {
  preview: (entityId: string | null, definition: ReportQueryDefinition | null, rawQuery: string | null = null, pagination: ReportPagination | null = null) =>
    request(`${base(entityId)}/preview`, decodeReportRun, json('POST', { definition: draftEnvelope(definition, rawQuery), pagination })),

  previewSql: (entityId: string | null, definition: ReportQueryDefinition) =>
    request(`${base(entityId)}/preview/sql`, (raw) => {
      if (!isRecord(raw)) throw new Error('Malformed report SQL response')
      return requireString(raw.sql, 'sql')
    }, json('POST', { definition: structuredEnvelope(definition) })),

  exportPreview: async (entityId: string | null, definition: ReportQueryDefinition | null, rawQuery: string | null = null) => {
    const response = await send(`${base(entityId)}/preview/export`, {
      ...json('POST', { definition: draftEnvelope(definition, rawQuery) }),
      headers: { 'Content-Type': 'application/json', Accept: 'text/csv' },
    })
    return {
      blob: await response.blob(),
      filename: filenameFromContentDisposition(response.headers.get('Content-Disposition'), 'report.csv'),
    }
  },
}
